<template>
    <div class="my-center">
        <PageHeader></PageHeader>
        <van-divider>第三方账号快捷登录</van-divider>
        <div class="register">
            <img src="../assets/微信.png" alt="">
            <img src="../assets/QQ.png" alt="">
            <img src="../assets/微博.png" alt="">
        </div>
    </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";

export default {
    components: {
        PageHeader
    }
};
</script>

<style lang="less">
.my-center {
    width: 100%;
    height: 100vh;
    background: rgb(241, 241, 241);
    .van-divider {
        margin-top: 180px;
        background: rgb(241, 241, 241);
        font-size: 12px;
    }
    .register{
        text-align: center;
        img{
            margin: 15px;
        }
    }
}
</style>
